import type { ChangeEvent } from "react";
import {
  Input,
  InputLabel,
  FormControl,
  InputAdornment,
  FormHelperText
} from "@mui/material";

interface CurrencyInputProps {
  label: string;
  error?: boolean;
  helperText?: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const CurrencyInput = ({
  label,
  value,
  onChange,
  error = false,
  helperText = ""
}: CurrencyInputProps) => {
  return (
    <FormControl fullWidth variant="standard" error={error}>
      <InputLabel htmlFor={`${label}-currency-input`}>{label}</InputLabel>
      <Input
        id={`${label}-currency-input`}
        value={value}
        onChange={onChange}
        startAdornment={<InputAdornment position="start">$</InputAdornment>}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
